import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Text,
    View,
    Image,
    TextInput,
    TouchableOpacity,
    Linking,
    ActivityIndicator
} from 'react-native'
import { push } from 'react-router-redux'
import styles from './styles'

import { stateGetIn } from '../../lib/index'

import MainReducer from '../main/reducer'
import LoginReducer from './reducer'

import PinInput from '../../components/pinInput/index'

class Login extends Component {
    static NAME = 'Login'

    constructor(props) {
        super(props)

        this.state = {}
    }

    componentDidMount() {
        if (this.props.match) {
            this.checkForEmailLogin(this.props.match)
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.noBusinessError) {
            nextProps.setStage('error')
        }

        return null
    }

    checkForEmailLogin(match){
        if (
            match &&
            match.params &&
            'undefined' !== typeof match.params.email &&
            'undefined' !== typeof match.params.pin
        ) {
            this.props.setStage('link')
            this.props.setEmail(decodeURIComponent(match.params.email))

            this.props.verifyPin(
                decodeURIComponent(match.params.email),
                decodeURIComponent(match.params.pin)
            )
        }
    }

    supportLink() {
        Linking.openURL('mailto://support@meetcarrot.xyz?Subject=Problems%20with%20Merchant%20Dashboard')
    }

    render() {
        const {
            isLoading,
            setStage,
            stage,
            email,
            emailError,
            setPin,
            pin,
            pinError,
            // noBusinessError,
            setEmail,
            requestPin,
            verifyPin,
            environment
        } = this.props

        return (
            <View style={styles.container}>
                {('main' === stage) && <View style={styles.page}>
                    <View style={styles.mainSpacers2Logo}>
                        <Image style={styles.logo}
                            source={require('../../images/logo.png')} />
                    </View>
                    <View style={styles.mainSpacers1}>
                        {isLoading && <ActivityIndicator size={'large'} color={'#FF009B'}
                            style={{ marginBottom: 10 }} />}

                        <Text style={styles.title}>
                            Merchant Login
                        </Text>
                    </View>

                    <View style={styles.mainSpacers2}>
                        <TextInput
                            style={styles.mainEmail}
                            underlineColorAndroid={'transparent'}
                            placeholder={'Enter Your Email Address'}
                            onChangeText={setEmail}
                            onSubmitEditing={requestPin.bind(this, email)} />

                        {emailError && <Text style={styles.errorText}>
                            {emailError}
                        </Text>}
                    </View>

                    <View style={styles.mainSpacers2}>
                        <TouchableOpacity
                            style={styles.mainButton}
                            onPress={requestPin.bind(this, email)}
                            activeOpacity={0.8}>
                                <Text style={styles.mainButtonText}>
                                    LOG IN
                                </Text>
                        </TouchableOpacity>
                    </View>

                    {environment && 'live' !== environment &&
                        <View style={{ position: 'absolute', bottom: 10}}>
                            <Text style={{ fontSize: 14, color: 'red' }}>
                                {environment.toUpperCase()}
                            </Text>
                        </View>}
                </View>}

                {('emailed' === stage) && <View style={styles.page}>
                    <View style={styles.emailedSpacers1}>
                        <Image style={styles.checkmark}
                            source={require('../../images/check_email.png')} />

                        <Text style={styles.title}>
                            Check Your Email
                        </Text>
                    </View>

                    <View style={styles.emailedSpacers2}>
                        <Text style={styles.body}>
                            Email will be sent to {'\n'}
                            <Text style={{ fontWeight: 'bold' }}>
                                {email ? email : 'your email address'}
                            </Text> {'\n'}
                            If the account exists.
                        </Text>
                    </View>

                    <View style={styles.emailedSpacers1}>
                        {isLoading && <ActivityIndicator size={'large'} color={'#FF009B'}
                            style={{ marginBottom: 10 }} />}
                    </View>

                    <View style={styles.emailedSpacers2}>
                        <TouchableOpacity
                            style={styles.emailedButton}
                            onPress={setStage.bind(this, 'pin')}
                            activeOpacity={0.8}>
                                <Text style={styles.emailedButtonText}>
                                    Email Not Working? {'\n'}
                                    Manually Enter Pin
                                </Text>
                        </TouchableOpacity>
                    </View>
                </View>}

                {('link' === stage) && <View style={styles.page}>
                    <View style={styles.emailedSpacers1}>
                        {isLoading && <ActivityIndicator size={'large'} color={'#FF009B'}
                            style={{ marginBottom: 10 }} />}

                        <Text style={styles.title}>
                            Email Link
                        </Text>
                    </View>


                    <View style={styles.emailedSpacers2}>
                        <Text style={styles.body}>
                            Logging in as {'\n'}
                            <Text style={{ fontWeight: 'bold' }}>
                                {email ? email : 'your email address'}
                            </Text> {'\n'}
                        </Text>

                        {emailError && <TouchableOpacity
                            style={styles.emailedButton}
                            onPress={setStage.bind(this, 'main')}
                            activeOpacity={0.8}>
                                <Text style={styles.errorText}>
                                    {emailError}
                                </Text>
                        </TouchableOpacity>}

                        {pinError && <TouchableOpacity
                            style={styles.emailedButton}
                            onPress={setStage.bind(this, 'pin')}
                            activeOpacity={0.8}>
                                <Text style={styles.errorText}>
                                    {pinError}
                                </Text>
                        </TouchableOpacity>}
                    </View>

                    <View style={styles.emailedSpacers2}>
                        <TouchableOpacity
                            style={styles.emailedButton}
                            onPress={setStage.bind(this, 'pin')}
                            activeOpacity={0.8}>
                                <Text style={styles.emailedButtonText}>
                                    Email Link Not Working? {'\n'}
                                    Manually Enter Pin
                                </Text>
                        </TouchableOpacity>
                    </View>
                </View>}

                {('pin' === stage) && <View style={styles.page}>
                    <View style={styles.mainSpacers1}>
                        {isLoading && <ActivityIndicator size={'large'} color={'#FF009B'}
                            style={{ marginBottom: 10 }} />}

                        <Text style={styles.title}>
                            Enter Pin
                        </Text>
                    </View>

                    <View style={styles.mainSpacers2}>
                        <Text style={styles.body}
                            numberOfLines={2}
                            ellipsizeMode={'tail'}>
                            Enter the pin we sent to{'\n'}
                            <Text style={{ fontWeight: 'bold' }}>
                                {email ? email : 'your email address'}
                            </Text>
                        </Text>

                        <PinInput
                            pinStyle={styles.pinInput}
                            pinOutput={(pin) => { setPin(pin) }}
                            pinSubmit={(pin) => { verifyPin(email, pin) }}
                            editable={this.props.isLoading ? false : true}
                            />

                        {emailError && <TouchableOpacity
                            style={styles.emailedButton}
                            onPress={setStage.bind(this, 'main')}
                            activeOpacity={0.8}>
                                <Text style={styles.errorText}>
                                    {emailError}
                                </Text>
                        </TouchableOpacity>}

                        {pinError && <Text style={styles.errorText}>
                            {pinError}
                        </Text>}
                    </View>

                    <View style={styles.mainSpacers2}>
                        <TouchableOpacity
                            style={styles.mainButton}
                            onPress={verifyPin.bind(this, email, pin)}
                            activeOpacity={0.8}>
                                <Text style={styles.mainButtonText}>
                                    LOG IN
                                </Text>
                        </TouchableOpacity>
                    </View>
                </View>}

                {('error' === stage) && <View style={styles.page}>
                    <View style={styles.emailedSpacers1}>
                        {isLoading && <ActivityIndicator size={'large'} color={'#FF009B'}
                            style={{ marginBottom: 10 }} />}

                        <Text style={styles.errorTitle}>
                            No Valid Business
                        </Text>
                    </View>

                    <View style={styles.emailedSpacers2}>
                        <Text style={styles.body}>
                            is avaiable for {'\n'}
                            <Text style={{ fontWeight: 'bold' }}>
                                {email ? email : 'your email address'}
                            </Text> {'\n'}
                        </Text>
                    </View>

                    <View style={styles.emailedSpacers2}>
                        <Text style={[styles.emailedButtonText, { marginTop: 20 }]}>
                            Problems?  Email Us at
                        </Text>
                        <TouchableOpacity
                            style={styles.emailedButton}
                            onPress={this.supportLink.bind(this)}>
                            <Text style={styles.emailedButtonText}>
                                support@meetcarrot.xyz
                            </Text>
                        </TouchableOpacity>
                    </View>
                </View>}
            </View>
        )
    }
}

const mapStateToProps = (state) => ({
    isLoading: stateGetIn(state, LoginReducer.NAME, ['loading'], 'Login', false),
    stage: stateGetIn(state, LoginReducer.NAME, ['stage'], 'Login', 'main'),
    email: stateGetIn(state, LoginReducer.NAME, ['email'], 'Login'),
    pin: stateGetIn(state, LoginReducer.NAME, ['pin'], 'Login'),
    emailError: stateGetIn(state, LoginReducer.NAME, ['email_error'], 'Login'),
    pinError: stateGetIn(state, LoginReducer.NAME, ['pin_error'], 'Login'),
    noBusinessError: stateGetIn(state, LoginReducer.NAME, ['no_business_error'], 'Login'),
    environment: stateGetIn(state, MainReducer.NAME, ['environment'], 'Login')
})

const mapDispatchToProps = (dispatch) => ({
    goHome: () => {
        dispatch(push('/'))
    },
    setStage: (stage) => {
        dispatch(LoginReducer.clearErrors())
        dispatch(LoginReducer.setStage(stage))
    },
    setEmail: (email) => {
        dispatch(LoginReducer.clearErrors())
        dispatch(LoginReducer.setEmail(email))
    },
    requestPin: (email) => {
        dispatch(LoginReducer.requestPin(email))
    },
    setPin: (pin) => {
        dispatch(LoginReducer.setPin(pin))
    },
    verifyPin: (email, pin) => {
        dispatch(LoginReducer.verifyPin(email, pin))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/containers/login/index.js